<h1 class="log-title">@if (campaignName) {{{ campaignName }} — }Adventure Log</h1>
<adventure-log-sessions [sessions]="sessions"></adventure-log-sessions>
<adventure-log-notes [notes]="notes"></adventure-log-notes>
<adventure-log-bestiary [bestiary]="bestiary"></adventure-log-bestiary>
